// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"parabola"},"nodeName":"g","children":[{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M3 12C3.9 12 4.8 10.9 6.6 8.5C7.35 7.5 8.85 3 12 3C15.15 3 16.65 7.5 17.4 8.5C19.2 10.9 20.1 12 21 12","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"id":"stroke2","stroke":"currentColor","d":"M3 19H12M3 19V20M3 19V17M12 19H21M12 19V20M12 19V17M21 19V20M21 19V17","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-parabola')
export default class ParabolaIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'parabola',
    }
  }
}
